import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	mainContainer: {
		margin: "2.5rem"
	},
	sectionContainer: {
		marginBottom: "4rem"
	},
	verticalSpacing: {
		margin: "0 2.5rem"
	},
	headerContainer: {
		top        : "70px",
		width      : "100%",
		height     : "110px",
		zIndex     : 10,
		position   : "fixed",
		background : "#000000"
	},
	cardListContainer: {
		paddingTop: "calc(3.5rem + 70px)"
	},
	containerClass: {
		margin: "2rem 2.5rem"
	},
	// mobile css
	mobileMainContainer: {

	},
	liveText: {
		fontWeight : "500",
		fontSize   : "1.8rem",
		margin     : "1rem"
	}
} ) );
